// extracted by mini-css-extract-plugin
export default {"sportMarket":"MarketAccordion_sportMarket__P5zeY","oddsBtn":"MarketAccordion_oddsBtn__6mFpe"};